/**
 * 顶部标题栏
 * Created at 2021-10-02 23:51
 * @author teapot
 */
import { Image, Select ,DatePicker } from "antd";
import { PolicyCategory } from "../../model/OtherModel";
import "./index.css";

const { Option } = Select;

const HeadView = ({
  imgs,
  title,
  subTitle,
  list,
  onPress,
  dfValue,
  onData,
}: {
  imgs: string;
  title: string;
  subTitle?: string;
  list?: PolicyCategory[];
  dfValue?:Number 
  onPress?: (value: string) => void;
  onData?: (value: any,date:any) => void;
}) => {
  return (
    <div
      className="header-bottom"
      style={
        subTitle
          ? {
              // borderBottomWidth: "1px",
              // borderBottomStyle: "solid",
              // borderBottomColor: "#ccc",
            }
          : {}
      }
    >
      <div className="image-view header-center">
        <Image src={imgs} preview={false} className="image-view" />

        <div className="image-view-title">
          {title}
          <div className="image-view-line" />
        </div>
      </div>
      {subTitle ? (
        <div className="nav-row-center ">
          <div className="header-menu-title">{subTitle}</div>
          <div className="nav-placeholder"></div>
          <DatePicker picker="year"   onChange={onData}>
         


          </DatePicker>
          {list &&
            list.map(
              (item: { value: string[]; name: string }, index: number) => {
                return (
                  <Select
                    defaultValue={0}
                    key={index}
                    // value={dfValue}
                    onChange={(value) => {
                      const obj = { k: index, v: value };
                      onPress && onPress(JSON.stringify(obj));
                    }}
                    className="head-select"
                  >
                    {item.value.map((v, i) => {
                      return (
                        <Option key={i} value={i}>
                          {v}
                        </Option>
                      );
                    })}
                  </Select>
                );
              }
            )}
        </div>
      ) : null}
    </div>
  );
};

export default HeadView;
